import React from 'react'
import Link from 'next/link'
import { StyleMenuMobile } from '../styles'
import { IconeUsuario } from '../index'
import Image from 'next/image'
import { IconClose, IconSocialFacebook, IconUser } from '@gazin/ecommerce-ui'

export default function MobileMenu({ logado, sidebar, setSidebar }) {
  return (
    <StyleMenuMobile sidebar_open={sidebar}>
      <div className="cont">
        <button
          type="button"
          className="close"
          onClick={() => {
            setSidebar(false)
          }}
        >
          Menu <IconClose width="1.0625rem" height="1.0625rem" />
        </button>
        <div className="item-menu">
          <div className="title">
            <IconUser width="1.375rem" height="1.5rem" color="#fff" />
            <h2>Minha conta</h2>
          </div>

          <ul>
            <li>
              <Link
                href={logado ? '/conta' : '/login'}
                as={logado ? '/conta' : '/login'}
                shallow
                prefetch={false}
              >
                Meus dados
              </Link>
            </li>
            <li>
              <Link
                href={logado ? '/conta/alterar/email' : '/login'}
                as={logado ? '/conta/alterar/email' : '/login'}
                shallow
                prefetch={false}
              >
                Alterar meu e-mail
              </Link>
            </li>
            <li>
              <Link
                href={logado ? '/conta/alterar/senha' : '/login'}
                as={logado ? '/conta/alterar/senha' : '/login'}
                shallow
                prefetch={false}
              >
                Alterar senha
              </Link>
            </li>
          </ul>
        </div>

        <div className="item-menu">
          <div className="title">
            <Link
              href={logado ? '/conta/pedidos' : '/login'}
              as={logado ? '/conta/pedidos' : '/login'}
              shallow
              prefetch={false}
            >
              <Image src={IconeUsuario} alt="Usuários" width="33" height="28" />
              <h2>Meus pedidos</h2>
            </Link>
          </div>
          <ul>
            <li>
              <Link
                href={logado ? '/conta/pedidos' : '/login'}
                as={logado ? '/conta/pedidos' : '/login'}
                shallow
                prefetch={false}
              >
                Acompanhar Pedidos
              </Link>
            </li>
            <li>
              <Link
                href={logado ? '/conta/segunda-via' : '/login'}
                as={logado ? '/conta/segunda-via' : '/login'}
                shallow
                prefetch={false}
              >
                Solicitar 2ª via do boleto
              </Link>
            </li>
          </ul>
        </div>

        <div className="social">
          <span>Acompanhe nas redes sociais</span>
          <ul>
            <li>
              <a
                href="https://www.facebook.com/gazin"
                target="_blank"
                rel="noreferrer"
              >
                <IconSocialFacebook width=".6875rem" height="1.125rem" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </StyleMenuMobile>
  )
}
